import { appConfig } from "../AppConfig/variables";
import printJS from "print-js";
import "../../assets/css/TreeTable.css";
import toolbarConfiguration from "../Toolbar/toolbarConfig";
import { msalInstance } from "../..";
import { loginRequest } from "../Auth/AuthConfig";

const {
  category,
  sku,
  DC,
  supplier,
  tier2_suppliers,
  tier2_skus,
  supplier_org,
  assembly_item,
  issue_type,
  incident_type,
  fsc_manager,
  product_group_manager,
  product_type
} = toolbarConfiguration.filterMap;

export const COMMON_FILTERS_BY_KEYS = [
  "supp_grp_id",
  "supp_id",
  "sku_grp_id",
  "wrin_id",
  "dc_id",
  "tier2_supp_id",
  "tier2_sku_id",
  "status",
  "risk_type",
  "event_id",
  "assembly_item_id",
];

export const COMMON_FILTERS_BY_QUALITY_KEYS = [
  category.filterCallId,
  sku.filterCallId,
  supplier.filterCallId,
  DC.filterCallId,
  supplier_org.filterCallId,
  assembly_item.filterCallId,
  issue_type.filterCallId,
  incident_type.filterCallId,
  product_type.filterCallId
];

export const DEFAULT_EMPTY_KEYS = ["status", "risk_type"];

export const LEVEL_KEY_MAP = {
  high: "H",
  med: "M",
  low: "L",
};

export function createBaseFilter(filterCriteria) {
  return {
    [category.filterCallId]: filterCriteria[category.filterCallId],
    [sku.filterCallId]: filterCriteria[sku.filterCallId],
    [supplier.filterCallId]: filterCriteria[supplier.filterCallId],
    [DC.filterCallId]: filterCriteria[DC.filterCallId],
    [tier2_suppliers.filterCallId]:
      filterCriteria[tier2_suppliers.filterCallId],
    [tier2_skus.filterCallId]: filterCriteria[tier2_skus.filterCallId],
    [supplier_org.filterCallId]: filterCriteria[supplier_org.filterCallId],
    [assembly_item.filterCallId]: filterCriteria[assembly_item.filterCallId],
  };
}

export function baseFilterForQualityComplaints(filterCriteria) {
  return {
    [category.filterCallId]: filterCriteria[category.filterCallId],
    [sku.filterCallId]: filterCriteria[sku.filterCallId],
    [supplier.filterCallId]: filterCriteria[supplier.filterCallId],
    [DC.filterCallId]: filterCriteria[DC.filterCallId],
    [supplier_org.filterCallId]: filterCriteria[supplier_org.filterCallId],
    [assembly_item.filterCallId]: filterCriteria[assembly_item.filterCallId],
    [issue_type.filterCallId]: filterCriteria[issue_type.filterCallId],
    [incident_type.filterCallId]: filterCriteria[incident_type.filterCallId],
    [product_type.filterCallId]: filterCriteria[product_type.filterCallId]
  };
}

export function fetchAccessToken() {
  const accounts = msalInstance.getAllAccounts();
  const request = {
    ...loginRequest,
    account: accounts[0]
  };

  return msalInstance.acquireTokenSilent(request).then(async(response) => {
    return await response.idToken;
  }).catch((err) => {
    console.log(err);
    msalInstance.acquireTokenRedirect(request)
  });
}

//METHOD TO GET THE ENTIRE HEADER DATA
export function getHdrCounts(url, data) {
  return new Promise(async (resolve, reject) => {
    const accessToken = await fetchAccessToken();
    fetch(url, {
      mode: "cors",
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${accessToken}`
      },
    })
      .then((res) => res.json())
      .then((result) => {
        resolve(result.counts);
      })
      .catch(function (err) {
        console.log("Error occured fetching icon data!!");
        console.log(err);
        resolve([]);
      });
  });
}

export function getHdrCountsWithSignal(url, data, controller) {
  return new Promise(async (resolve, reject) => {
    const accessToken = await fetchAccessToken();
    fetch(url, {
      mode: "cors",
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${accessToken}`
      },
      signal: controller.signal,
    })
      .then((res) => res.json())
      .then((result) => {
        resolve(result.counts);
      })
      .catch(function (err) {
        console.log("Error occured fetching icon data!!");
        console.log(err);
        reject(err);
      });
  });
}

export function getPostData(url, data) {
  return new Promise(async (resolve, reject) => {
    const accessToken = await fetchAccessToken();
    fetch(url, {
      mode: "cors",
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${accessToken}`
      },
    })
      .then((res) => res.json())
      .then((result) => {
        resolve(result);
      })
      .catch(function (err) {
        console.log("Error occured fetching data!!");
        console.log(err);
        resolve([]);
      });
  });
}

export function getPostDataWithSignal(url, data, controller) {
  return new Promise(async (resolve, reject) => {
    const accessToken = await fetchAccessToken();
    fetch(url, {
      mode: "cors",
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${accessToken}`
      },
      signal: controller.signal,
    })
      .then((res) => res.json())
      .then((result) => {
        resolve(result);
      })
      .catch(function (err) {
        console.log("Error occured fetching data!!");
        console.log(err);
        reject(err);
      });
  });
}

export function getFileDataWithSignal(url, data, controller) {
  return new Promise(async (resolve, reject) => {
    const accessToken = await fetchAccessToken();
    fetch(url, {
      mode: "cors",
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json"
      },
      signal: controller.signal,
    })
      .then((result) => {
        resolve(result);
      })
      .catch(function (err) {
        console.log("Error occured fetching data!!");
        console.log(err);
        reject(err);
      });
  });
}

export function getFileDataWithGet(url) {
  return new Promise(async (resolve, reject) => {
    const accessToken = await fetchAccessToken();
    fetch(url, {
      mode: "cors",
      method: "GET",
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json"
      },
    })
      .then((result) => {
        resolve(result);
      })
      .catch(function (err) {
        console.log("Error occured fetching data!!");
        console.log(err);
        reject(err);
      });
  });
}

export function getData(url) {
  return new Promise(async (resolve, reject) => {
    const accessToken = await fetchAccessToken();
    fetch(url, {
      mode: "cors",
      method: "GET",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${accessToken}`
      },
    })
      .then((res) => res.json())
      .then((result) => {
        resolve(result);
      })
      .catch(function (err) {
        console.log("Error occured fetching data!!");
        console.log(err);
        resolve([]);
      });
  });
}

//METHOD TO COUNT THE MISSING HIGH,MED,LOW FOR WARNING MESSAGE
export function getWarningMsg(collection, chartType, header) {
  try {
    header.high = header.high ? header.high : 0;
    header.med = header.med ? header.med : 0;
    header.low = header.low ? header.low : 0;

    let high = 0;
    let med = 0;
    let low = 0;
    let message = `Missing ${chartType} risks`;
    collection &&
      collection.length > 0 &&
      collection.forEach((dataObj) => {
        console.log(dataObj);
        high += dataObj.high
          ? dataObj.high
          : dataObj.RiskLevel === "High"
          ? 1
          : 0;
        med += dataObj.med
          ? dataObj.med
          : dataObj.RiskLevel === "Medium"
          ? 1
          : 0;
        low += dataObj.low ? dataObj.low : dataObj.RiskLevel === "Low" ? 1 : 0;
      });

    high = header.high - high;
    med = header.med - med;
    low = header.low - low;

    if (high === 0 && med === 0 && low === 0) {
      return {};
    } else {
      return { message: message, high: high, med: med, low: low };
    }
  } catch (error) {
    console.log("error in CommonFunc getWarningMsg " + error);
  }
}

export function getWarningMsgWithLevels(
  collection,
  chartType,
  header,
  selectedLegends
) {
  try {
    header.high = header.high ? header.high : 0;
    header.med = header.med ? header.med : 0;
    header.low = header.low ? header.low : 0;

    let high = 0;
    let med = 0;
    let low = 0;
    let message = `Missing ${chartType} risks`;
    collection &&
      collection.length > 0 &&
      collection.forEach((dataObj) => {
        high += dataObj.high
          ? dataObj.high
          : dataObj.RiskLevel === "High"
          ? 1
          : 0;
        med += dataObj.med
          ? dataObj.med
          : dataObj.RiskLevel === "Medium"
          ? 1
          : 0;
        low += dataObj.low ? dataObj.low : dataObj.RiskLevel === "Low" ? 1 : 0;
      });

    high = header.high - high;
    med = header.med - med;
    low = header.low - low;

    if (high === 0 && med === 0 && low === 0) {
      return {};
    } else {
      const returnObject = { message: message, high: high, med: med, low: low };
      if (
        selectedLegends.length > 0 &&
        selectedLegends.indexOf("high") === -1
      ) {
        delete returnObject.high;
      }

      if (selectedLegends.length > 0 && selectedLegends.indexOf("med") === -1) {
        delete returnObject.med;
      }

      if (selectedLegends.length > 0 && selectedLegends.indexOf("low") === -1) {
        delete returnObject.low;
      }

      return returnObject;
    }
  } catch (error) {
    console.log("error in CommonFunc getWarningMsg " + error);
  }
}

export function onClickPrint(divID, title, landscape) {
  try {
    let style = [
      "@page {margin: 100px 30px; font-size: 10px}  .pigeon-attribution {display : none} .recharts-brush {display : none} .filter {display:none} .sr-only {display : none}  tr th:last-child{display : none } tr td:last-child{display : none } .table-bordered {font-size:11px} th {text-align:left}",
    ];
    if (landscape) {
      style = [
        "@page {margin: 50px 2px; font-size: 4px;  size: Letter landscape; }  .pigeon-attribution {display : none} .recharts-brush {display : none} .filter {display:none} .sr-only {display : none}  tr th:last-child{display : none } tr td:last-child{display : none } .table-bordered {font-size:11px} th {text-align:left}",
      ];
    }

    printJS({
      printable: divID,
      type: "html",
      scanStyles: false,
      style: style,
      documentTitle: `Havi Risk Management`,
      header: `${title}`,
      headerStyle:
        "text-align : center; font-size : 17px; font-weight : 400; margin-bottom :30px",
    });
  } catch (error) {
    console.log("Error in CommonFunc onClickPrint" + error);
  }
}

export function statusTooltip(className) {
  let statusColl = Object.keys(appConfig.riskStatus);
  try {
    return (
      <div className={className}>
        {statusColl.map((status) => {
          return (
            <div>
              <span>{status}</span> = {appConfig.riskStatus[status]}
            </div>
          );
        })}
      </div>
    );
  } catch (error) {
    console.log("error in CommonFunc statusTooltip " + error);
  }
}

export function sortByKey(arr, sortKey) {
  let sortedArr;
  if (sortKey === "number") {
    sortedArr = arr.toSorted((a, b) => {
      return b.high + b.med + b.low - (a.high + a.med + a.low);
    });
  } else if (sortKey === "asc") {
    sortedArr = arr.toSorted((a, b) =>
      a.name < b.name ? -1 : a.name > b.name ? 1 : 0
    );
  } else if (sortKey === "desc") {
    sortedArr = arr.toSorted((a, b) =>
      a.name < b.name ? 1 : a.name > b.name ? -1 : 0
    );
  }

  return sortedArr;
}

export function sortByKeyAscDesc(arr, sortKey) {
  let sortedArr;
  if (sortKey === "desc") {
    sortedArr = arr.toSorted((a, b) => {
      return b.high + b.med + b.low - (a.high + a.med + a.low);
    });
  } else if (sortKey === "asc") {
    sortedArr = arr.toSorted(
      (a, b) => a.high + a.med + a.low - (b.high + b.med + b.low)
    );
  } else {
    sortedArr = arr;
  }

  return sortedArr;
}

export function sortByKeyAscDescWithSortByKey(arr, sortKey, sortByKey) {
  let sortedArr;
  if (sortKey === "desc") {
    sortedArr = arr.toSorted((a, b) => 
       b[sortByKey] - a[sortByKey]
    );
  } else if (sortKey === "asc") {
    sortedArr = arr.toSorted(
      (a, b) => a[sortByKey] - b[sortByKey]
    );
  } else {
    sortedArr = arr;
  }

  return sortedArr;
}

export const getStatusCountFromObj = (data, statusKey) => {
  const STATUSES = {
    NEW: "New",
    IN_PROGRESS: "In Progress",
    ACTIONED: "Actioned",
    CLOSED: "Closed",
    NA: "NA",
  };

  const status = {
    New: 0,
    "In Progress": 0,
    Actioned: 0,
    Closed: 0,
    NA: 0,
  };

  data.forEach((item) => {
    if (item[statusKey] === STATUSES.NEW) {
      status["New"] += 1;
    } else if (item[statusKey] === STATUSES.IN_PROGRESS) {
      status["In Progress"] += 1;
    } else if (item[statusKey] === STATUSES.ACTIONED) {
      status["Actioned"] += 1;
    } else if (item[statusKey] === STATUSES.CLOSED) {
      status["Closed"] += 1;
    } else {
      status["NA"] += 1;
    }
  });

  return status;
};

export const checkSameKeysInOtherObj = (obj1, obj2) => {
  let hasSameKeys = true;

  const keysObj1 = Object.keys(obj1);

  for (let i = 0; i < keysObj1.length; i++) {
    const key1 = keysObj1[i];
    if (!obj2.hasOwnProperty(key1)) {
      hasSameKeys = false;
      break;
    } else {
      console.log(obj1, obj2, key1, obj2[key1], obj1[key1]);
      if (obj2[key1] !== obj1[key1]) {
        console.log(obj2[key1], obj1[key1]);
        hasSameKeys = false;
        break;
      }
    }
  }

  return hasSameKeys;
};

export function capitalizeFirstCharacter(str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}